import React, { useState } from 'react';
import { Dropdown, Button, Tooltip } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { useDispatch } from "react-redux";
import { downloadPddReport } from '../../../../redux/slice/getPDDData';
import { trackFeatureAction } from '../../../../analytics/googleAnalytics';

function Reports({ jwtBearer }) {
    const dispatch = useDispatch();
    const [downloading, setDownloading] = useState(null);

    const handleDownload = async (type, fileName, label) => {
        setDownloading(type);

        try {
            await dispatch(
                downloadPddReport({
                    type,
                    fileName,
                    jwtBearer
                })
            ).unwrap();

            trackFeatureAction(
                "PDD",
                "Reports",
                "download",
                {
                    report: label
                }
            );
        } catch (error) {
            console.error(
                `Failed to download ${label}:`,
                error
            );
        } finally {
            setDownloading(null);
        }
    };

    const items = [
        {
            key: 'kit_status_report',
            label: 'Kit Status Report',
            onClick: () => handleDownload('kit_status_report', 'Kit_Status_Report'),
            disabled: downloading === 'kit_status_report',
        },
        {
            key: 'query_report',
            label: 'Query Report',
            onClick: () => handleDownload('query_report', 'Query_Report'),
            disabled: downloading === 'query_report',
        },
        {
            key: 'verification_report',
            label: 'Verification Report',
            onClick: () => handleDownload('verification_report', 'Verification_Report'),
            disabled: downloading === 'verification_report',
        }
    ];

    return (
        <div style={{
            display: "flex",
            gap: "4px",
            borderRadius: "10px",
            padding: "4px",
            backgroundColor: "#f5f5f5",
            // border: "1px solid #e8e8e8"
        }}>
            <Dropdown menu={{ items }} trigger={['click']} placement="bottomRight">
                <Button
                    type={downloading ? "primary" : "text"}
                    icon={<DownloadOutlined />}
                    loading={!!downloading}
                    style={{
                        borderRadius: "8px",
                        padding: "8px 16px",
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    Download
                </Button>
            </Dropdown>
        </div>
    );
}

export default Reports;